<template>
  <v-card flat>
    <v-tabs v-model="tab" centered grow class="pb-3">
      <v-tab>
        <v-icon small class="mx-2">mdi-database-import</v-icon> Import</v-tab
      >
      <v-tab> <v-icon small class="mx-2">mdi-cogs</v-icon> Process </v-tab>
      <v-tab> <v-icon small class="mx-2">mdi-magnify</v-icon> Lookup </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <import-transmittals v-if="tab == 0"></import-transmittals>
      </v-tab-item>
      <v-tab-item>
        <process-transmittals v-if="tab == 1"></process-transmittals>
      </v-tab-item>
      <v-tab-item>
        <transmittals-lookup v-if="tab == 2"></transmittals-lookup>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import ImportTransmittals from "./import-transmittals.vue";
import ProcessTransmittals from "./process-transmittals.vue";
import TransmittalsLookup from "./transmittals-lookup.vue";
export default {
  components: {
    ImportTransmittals,
    ProcessTransmittals,
    TransmittalsLookup,
  },
  data() {
    return {
      tab: 0, // index-based
    };
  },
};
</script>
